import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import { showNotification } from '../../action/NotificationAction';
import { PATH } from '../../../utils/Constants';
import profileImg from '../../../utils/images/profileImg.png';
import {
    educatorProfileUpload,
    getEducatorDetails,
} from '../../action/educator/EducatorProfileAction';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { getUserInformation } from '../../action/UserAction';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */

class StudentProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            mobileNav: false,
            educatorDetail: {},
            profileImage: null,
            btnLoading: false,
        };
    }

    //componentDidMount
    componentDidMount() {
        this.getEducatorDetailsInfo();
    }

    // getEducatorDetailsInfo
    getEducatorDetailsInfo() {
        this.props.getEducatorDetails((result) => {
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({ educatorDetail: result.response, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.props.showNotification(result.message, RESPONSE_CONSTANT.ERROR);
            }
        });
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    //handleImageUpload
    handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (
                file.type === 'image/png' ||
                file.type === 'image/jpeg' ||
                file.type === 'image/jpg'
            ) {
                if (file.size <= 10485760) {
                    const reader = new FileReader();

                    reader.onloadend = () => {
                        const base64 = reader.result;
                        this.setState({
                            profileImage: base64,
                        });
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.setState({ profileImage: null });
                    this.props.showNotification(
                        'Please upload an image file with a size less than 10MB.',
                        'warning'
                    );
                }
            } else {
                this.setState({ profileImage: null });
                this.props.showNotification(
                    'Please upload an image file with a PNG, JPEG, or JPG format.',
                    'warning'
                );
            }
        }
    };

    //submit
    submit = () => {
        this.setState({ btnLoading: true });
        const { firstName, lastName, gender, email, mobileNumber, dob, associatedLevels } =
            this.state.educatorDetail;
        const { profileImage } = this.state;
        const values = {
            firstName: firstName,
            lastName: lastName,
            email: email,
            mobileNumber: mobileNumber,
            dob: dob,
            gender: gender === 'Male' ? 'M' : 'F',
            associatedLevels: associatedLevels,
            image: profileImage,
        };
        this.props.educatorProfileUpload(values, (response) => {
            this.setState({ btnLoading: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                this.props.getUserInformation((res) => {});
                return;
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                }
                return;
            }
        });
    };

    /**
     * Render page
     */
    render() {
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.MY_PROFILE}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow">
                    <Headers
                        {...this.props}
                        title="Profile"
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-lg font-medium text-white">Profile</h6>
                        </div>
                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <div className="items-center justify-between px-4 pt-6 sm:flex sm:px-8">
                                <div className="flex flex-col w-full p-6 rounded-lg bg-card">
                                    <div className="grid-cols-12 gap-6 sm:grid">
                                        <div className="col-span-12 py-4 rounded-lg sm:col-span-3 bg-card h-fit">
                                            <div className="relative">
                                                <div className="mx-auto user-img">
                                                    <img
                                                        src={
                                                            this.state.profileImage ||
                                                            (this.state.educatorDetail.image
                                                                ? this.state.educatorDetail.image
                                                                : profileImg)
                                                        }
                                                        alt=""
                                                        className="object-cover w-full h-full rounded-full"
                                                    />
                                                    <label
                                                        htmlFor="file-upload"
                                                        className="flex items-center justify-center w-8 h-8 text-white rounded-full cursor-pointer camera-btn bg-UIprimary"
                                                    >
                                                        <svg
                                                            width="21"
                                                            height="20"
                                                            viewBox="0 0 21 20"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M6.22047 18.2813H14.758C17.0064 18.2813 17.9026 16.9045 18.0085 15.2263L18.4321 8.49734C18.5461 6.73769 17.1449 5.24688 15.3771 5.24688C14.8802 5.24688 14.424 4.96175 14.1959 4.52184L13.6093 3.3406C13.2346 2.59927 12.257 1.98828 11.4261 1.98828H9.56054C8.72145 1.98828 7.74387 2.59927 7.36913 3.3406L6.78258 4.52184C6.55448 4.96175 6.09827 5.24688 5.60134 5.24688C3.83355 5.24688 2.43235 6.73769 2.5464 8.49734L2.97002 15.2263C3.06778 16.9045 3.97204 18.2813 6.22047 18.2813Z"
                                                                stroke="white"
                                                                strokeWidth="1.22198"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M9.26726 6.87598H11.7112"
                                                                stroke="white"
                                                                strokeWidth="1.22198"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M10.4892 15.0228C11.9475 15.0228 13.1369 13.8334 13.1369 12.3752C13.1369 10.9169 11.9475 9.72754 10.4892 9.72754C9.03101 9.72754 7.84163 10.9169 7.84163 12.3752C7.84163 13.8334 9.03101 15.0228 10.4892 15.0228Z"
                                                                stroke="white"
                                                                strokeWidth="1.22198"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="file-upload"
                                                        name="file-upload"
                                                        className="sr-only"
                                                        onClick={(e) => {
                                                            e.target.value = null;
                                                        }}
                                                        onChange={this.handleImageUpload}
                                                        accept=".png,.jpeg,.jpg"
                                                    />
                                                </div>
                                                <div className="mt-4 text-center">
                                                    <p
                                                        className="text-[#F6F8FB] text-lg font-medium whitespace-nowrap truncate"
                                                        title={this.state.educatorDetail.name}
                                                    >
                                                        {this.state.educatorDetail.name
                                                            ? this.state.educatorDetail.name
                                                            : ''}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-span-12 p-6 mt-6 rounded-lg sm:col-span-9 bg-card sm:mt-0">
                                            <div className="lg:w-1/2">
                                                <div>
                                                    <label
                                                        htmlFor="select-subject"
                                                        className="block mb-2 text-base font-normal text-white"
                                                    >
                                                        Name
                                                    </label>
                                                    <input
                                                        value={
                                                            this.state.educatorDetail.name
                                                                ? this.state.educatorDetail.name
                                                                : ''
                                                        }
                                                        variant="filled"
                                                        className="w-full border bg-dateselect text-white text-white rounded block py-1.5 px-2 "
                                                        disabled
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        htmlFor="select-subject"
                                                        className="block mt-6 mb-2 text-base font-normal text-white"
                                                    >
                                                        Email
                                                    </label>
                                                    <input
                                                        value={
                                                            this.state.educatorDetail.email
                                                                ? this.state.educatorDetail.email
                                                                : ''
                                                        }
                                                        variant="filled"
                                                        className="w-full border bg-dateselect text-white text-white rounded block py-1.5 px-2"
                                                        disabled
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        htmlFor="select-subject"
                                                        className="block mt-6 mb-2 text-base font-normal text-white"
                                                    >
                                                        Mobile Number
                                                    </label>
                                                    <input
                                                        value={
                                                            this.state.educatorDetail.mobileNumber
                                                                ? this.state.educatorDetail
                                                                      .mobileNumber
                                                                : ''
                                                        }
                                                        variant="filled"
                                                        className="w-full border bg-dateselect text-white text-white rounded block py-1.5 px-2"
                                                        disabled
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        htmlFor="select-subject"
                                                        className="block mt-6 mb-2 text-base font-normal text-white"
                                                    >
                                                        Date Of Birth
                                                    </label>
                                                    <div className="relative flex flex-wrap items-stretch w-full mb-0">
                                                        <div className="flex w-full mb-2 border rounded border-black-10">
                                                            <div className="flex-grow">
                                                                <input
                                                                    value={
                                                                        this.state.educatorDetail
                                                                            .dob
                                                                            ? moment(
                                                                                  this.state
                                                                                      .educatorDetail
                                                                                      .dob
                                                                              ).format('MM/DD/YYYY')
                                                                            : ''
                                                                    }
                                                                    variant="filled"
                                                                    className="w-full border-none bg-dateselect text-white text-white rounded-l py-1.5 px-2"
                                                                    disabled
                                                                />
                                                            </div>
                                                            <div className="flex items-center bg-dateselect">
                                                                {/* <i className="mx-2 text-sm text-white fa-regular fa-calendar"></i> */}
                                                                <svg
                                                                    width="20"
                                                                    height="21"
                                                                    viewBox="0 0 20 21"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    className="mx-2"
                                                                >
                                                                    <path
                                                                        d="M6.66669 2.4165V4.9165"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="1.5"
                                                                        strokeMiterlimit="10"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M13.3333 2.4165V4.9165"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="1.5"
                                                                        strokeMiterlimit="10"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M2.91669 8.3252H17.0834"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="1.5"
                                                                        strokeMiterlimit="10"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M17.5 7.83317V14.9165C17.5 17.4165 16.25 19.0832 13.3333 19.0832H6.66667C3.75 19.0832 2.5 17.4165 2.5 14.9165V7.83317C2.5 5.33317 3.75 3.6665 6.66667 3.6665H13.3333C16.25 3.6665 17.5 5.33317 17.5 7.83317Z"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="1.5"
                                                                        strokeMiterlimit="10"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M13.0789 12.1667H13.0864"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M13.0789 14.6667H13.0864"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M9.99626 12.1667H10.0037"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M9.99626 14.6667H10.0037"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M6.91191 12.1667H6.91939"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M6.91191 14.6667H6.91939"
                                                                        stroke="#10DACE"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label
                                                        htmlFor="select-subject"
                                                        className="block mt-6 mb-2 text-lg font-normal text-white"
                                                    >
                                                        Gender
                                                    </label>
                                                    <div className="relative">
                                                        <select
                                                            id="subject"
                                                            name="subject"
                                                            value={
                                                                this.state.educatorDetail &&
                                                                this.state.educatorDetail.gender
                                                                    ? this.state.educatorDetail
                                                                          .gender
                                                                    : ''
                                                            }
                                                            className="block w-full p-2 pr-10 text-white border rounded appearance-none bg-dateselect"
                                                            disabled
                                                        >
                                                            <option
                                                                value={
                                                                    this.state.educatorDetail &&
                                                                    this.state.educatorDetail.gender
                                                                        ? this.state.educatorDetail
                                                                              .gender
                                                                        : ''
                                                                }
                                                                disabled
                                                            >
                                                                {this.state.educatorDetail &&
                                                                this.state.educatorDetail.gender
                                                                    ? this.state.educatorDetail
                                                                          .gender
                                                                    : ''}
                                                            </option>
                                                        </select>
                                                        <div className="absolute inset-y-0 flex items-center pointer-events-none right-3">
                                                            <svg
                                                                className="w-4 h-4 text-UIprimary"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 20 20"
                                                                fill="currentColor"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                    clipRule="evenodd"
                                                                />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div>
                          <label
                            htmlFor="select-subject"
                            className="block mt-6 mb-2 font-normal text-white"
                          >
                            Mapped Level 3 Name
                          </label>
                          {this.state.educatorDetail?.associatedLevels &&
                          this.state.educatorDetail?.associatedLevels
                            ?.length ? (
                            <div className="block w-full p-1 pb-6 text-white border rounded bg-dateselect">
                              {this.state.educatorDetail?.associatedLevels.map(
                                (name, index) => (
                                  <button
                                    key={index}
                                    className="px-2 mr-1 text-xs font-normal text-white rounded-lg bg-UIprimary whitespace-nowrap focus:bg-primary focus:text-white hover:bg-primary hover:text-white padding-slot selected-name table-ellipse"
                                    disabled
                                    title={name.name}
                                  >
                                    {name.name}
                                    <i className="align-middle fal fa-times ms-2"></i>
                                  </button>
                                )
                              )}
                            </div>
                          ) : (
                            <div className="block w-full p-2 pb-6 text-base bg-white border rounded border-black-10">
                              <p className="px-2 py-2 mb-1 text-base"></p>
                            </div>
                          )}
                        </div> */}
                                            </div>
                                            <div className="flex items-end justify-end mt-6 sm:mt-auto">
                                                <button
                                                    type="button"
                                                    className="w-full px-3 py-2 font-semibold text-white bg-black rounded-lg sm:w-1/6"
                                                    onClick={() =>
                                                        this.props.history.push(
                                                            `${PATH.IM_PHYSICIAN.DASHBOARD}/${this.props.match.params.userId}/`
                                                        )
                                                    }
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    className="rounded-lg bg-UIprimary px-3 py-1.5 text-white font-semibold text-white sm:w-1/6 w-full ml-4"
                                                    onClick={this.submit}
                                                    disabled={this.state.btnLoading}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        {this.state.btnLoading ? (
                                                            <Spinner color="#FFF" />
                                                        ) : (
                                                            'Save'
                                                        )}
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getEducatorDetails: (callback) => {
            dispatch(getEducatorDetails(callback));
        },
        getUserInformation: (callback) => {
            dispatch(getUserInformation(callback));
        },
        educatorProfileUpload: (values, callback) => {
            dispatch(educatorProfileUpload(values, callback));
        },
    };
};

export default connect(null, mapDispatchToProps)(StudentProfile);

